<template>
  <commodity-strategies
    :Analytics="Analytics"
    :colorTheme="colorTheme"
    :loadingAll="loadingAll"
    :processData="processData"
    :renderChartSignal="renderChartSignal"
    :isPrices="isPrices"
    :idChart="idChart"
    :asset="Analytics.assetType"
    @changeInfoTable="changeInfoTable"
    @onTableFormat="onHoverChart"
  />
</template>

<script>
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import CommodityStrategies from "./CommodityStrategies.vue";

export default {
  components: { CommodityStrategies },
  name: "CommodityPriceStrategies",
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics()
    },
    colorTheme: { required: true, type: Boolean, default: true },
    loadingAll: { required: true, type: Boolean, default: false },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 }
  },
  data() {
    return {
      isPrices: true,
      idChart: "pStrategies"
    };
  },
  methods: {
    changeInfoTable(val) {
      this.$emit("changeInfoTable", val);
    },
    onHoverChart(val) {
      this.$emit("onTableFormat", val);
    }
  }
};
</script>
